function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import useIsVisibleWithTransition, { TRANSITION_TIME } from '../hooks/useIsVisibleWithTransition.js';
import CloseIcon from './CloseIcon.js';
import useMessages from './useMessages.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function Modal(props) {
  const children = props.children,
    close = props.close,
    title = props.title,
    isOpen = props.isOpen;
  const overlayRef = useRef(null);
  const modalRef = useRef(null);
  useEffect(() => {
    if (typeof document !== 'undefined') {
      overlayRef.current = document.createElement('div');
      if (document.body) document.body.appendChild(overlayRef.current);
    }
    return () => {
      if (typeof document !== 'undefined' && document.body) {
        document.body.removeChild(overlayRef.current);
      }
    };
  }, []);
  const _useIsVisibleWithTran = useIsVisibleWithTransition(isOpen),
    _useIsVisibleWithTran2 = _slicedToArray(_useIsVisibleWithTran, 2),
    isVisible = _useIsVisibleWithTran2[0],
    closeWithTransition = _useIsVisibleWithTran2[1];
  const handleClose = useCallback(() => {
    closeWithTransition(close);
  }, [closeWithTransition, close]);
  const handleOverlayClick = useCallback(e => {
    if (!modalRef.current?.contains(e.target)) {
      handleClose();
    }
  }, [handleClose]);
  if (!overlayRef.current || !isOpen) return null;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/jsx(Overlay, {
    onClick: handleOverlayClick,
    visible: isVisible,
    children: /*#__PURE__*/jsxs(ModalContainer, {
      ref: modalRef,
      children: [/*#__PURE__*/jsx(ModalHeader, {
        close: handleClose,
        title: title
      }), /*#__PURE__*/jsx(ModalBody, {
        children: children
      })]
    })
  }), overlayRef.current);
}
const Overlay = styled.div.withConfig({
  shouldForwardProp: p => !['visible'].includes(p)
})`
  width: 100%;
  height: 100%;
  background-color: ${({
  theme
}) => theme.colors.overlay};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: scroll;
  position: fixed;
  top: 0;
  left: 0;
  opacity: ${({
  visible
}) => visible ? '1' : '0'};
  transition: opacity ${TRANSITION_TIME}ms;
  z-index: ${({
  theme
}) => theme.zIndex.overlay};
`;
function ModalHeader({
  title,
  close
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const messages = useMessages();
  return /*#__PURE__*/jsxs(Header, {
    children: [title && /*#__PURE__*/jsx(Title, {
      "data-synthetic-id": "modal_cookies",
      children: title
    }), close && /*#__PURE__*/jsx(CloseIcon, {
      onClick: close,
      ariaLabel: formatMessage(messages.ariaCloseButton)
    })]
  });
}
const ModalBody = styled.div`
  display: flex;
  padding: ${({
  theme
}) => `${theme.size.lg} ${theme.size.md}`};
`;
const Header = styled.div`
  display: flex;
  position: relative;
  min-height: 64px;
  padding: ${p => p.theme.size.md};
  border-bottom: ${p => p.theme.border.border};
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;
const Title = styled.span`
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: ${p => p.theme.colors.onBackground};
`;
const ModalContainer = styled.div`
  height: auto;
  margin: 100px 0 24px;
  min-width: 480px;
  border: none;
  border-radius: ${({
  theme
}) => theme.border.borderRadius};
  background-color: ${({
  theme
}) => theme.colors.background};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;

  @media (max-width: ${({
  theme
}) => theme.breakpoints.phone}px) {
    min-width: auto;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    border-radius: 0;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
`;
export { ModalHeader, Modal as default };
//# sourceMappingURL=Modal.js.map
